/**
 * CMSPreferenceCheckboxDirectiveController is a controller for handling the logic of a checkbox directive
 * in a CMS preference setting.
 *
 * @class
 * @param {Object} $injector - AngularJS injector service.
 * @param {Object} $scope - AngularJS scope service.
 * @param {Object} $rootScope - AngularJS rootScope service.
 * @param {Object} $signals - Custom signals service.
 * @param {Object} $interval - AngularJS interval service.
 */
class CMSPreferenceCheckboxDirectiveController {
    constructor($injector, $scope, $rootScope, $signals, $interval) {
        this.$injector = $injector;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$signals = $signals;
        this.$interval = $interval;

        // Initialize scope data with the preference data corresponding to the key
        this.$scope.data = this.$scope.prefData[this.$scope.theKey];
        // Generate a random ID for the checkbox
        this.$scope.randomId = angular.createUUID();

        // Determine if the checkbox should be disabled based on the valueKey and parent scope conditions
        if (this.$scope.data.valueKey === "includedInPDF" && 
            (this.$scope.parentScope.disabledIncludedInPDF || 
             this.$scope.parentScope.$parent.disabledIncludedInPDF || 
             this.$scope.parentScope.getScope().preferencesValues[this.$scope.data.valueKey] === 'disabled')) {
            this.$scope.disabledIncludedInPDF = true;
        } else {
            this.$scope.disabledIncludedInPDF = false;
        }
    }
}
CMSPreferenceCheckboxDirectiveController.$inject = ['$injector', '$scope', '$rootScope', '$signals', '$interval'];

/**
 * Registers the CMSPreferenceCheckbox directive with the provided module.
 *
 * @function
 * @param {Object} module - The AngularJS module to register the directive with.
 */
export default function registerCMSPreferenceCheckboxDirective(module) {
    module.directive('cmsPreferenceCheckbox', ['$compile', '$bridges', 'TaskDataService', function($compile, $bridges, TaskDataService) {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                theKey: '=key',
                prefData: '=data',
                parentScope: '=scope'
            },
            templateUrl: "/views/ib/contentobjects/helpers/cms-preference-checkbox.html",
            controller: CMSPreferenceCheckboxDirectiveController
        };
    }]);
}